import { useGetMediaEventList } from '@cobliteam/hooks/src/useCamera/useCameraMedia';
import { useFormContext } from '@cobliteam/ui/form';
import { endOfDay, startOfDay } from '@cobliteam/utils/date';
import type { FormSchemaType } from '../../mediaRequestSchema';
import MapEventMarker from './MapEventMarker';

/**
 * Manages and renders all map event markers based on the selected vehicle and date
 * Fetches media events and creates individual markers for each event
 */
const MapEventMarkers = () => {
  // Get form values for vehicle and date selection
  const { getValues } = useFormContext<FormSchemaType>();
  const { vehicle, date } = getValues();

  // Fetch media events for the selected vehicle and date
  const { data: mediaEvents } = useGetMediaEventList({
    vehicleIds: vehicle?.id ? [vehicle.id] : [],
    size: 1000,
    mediaPeriod: {
      start: startOfDay(date).valueOf(),
      end: endOfDay(date).valueOf(),
    },
  });

  // Render a marker for each media event
  return mediaEvents?.content.map((media) => <MapEventMarker key={media.id} media={media} />);
};

export default MapEventMarkers;
